import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog } from "@material-ui/core";
import { useIntl } from "react-intl";
import { ActionButton } from "../../../../components";
import { PERMISSAO_ETAPA, SITUACAO_LEAD, SITUACAO_REUNIAO } from "../../../../_common/constantes";
import { useUsuario } from "../../../../hooks";
import ModalAlterarTipoReuniao from "./ModalAlterarTipoReuniao";
import EditCalendar from "../../../../_common/icones/EditCalendar";
import permissions from "../../../../_common/permissions";
import usePermissaoEtapa from "../../../base-leads/pipeline/components/usePermissaoEtapa";

AlterarTipoReuniao.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  callback: PropTypes.func,
  claim: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  lead: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    grupos: PropTypes.arrayOf(PropTypes.number),
    preVendedorId: PropTypes.number,
    etapa: PropTypes.shape({
      id: PropTypes.number.isRequired,
      gateAnterior: PropTypes.number,
      funilId: PropTypes.number,
      funil: PropTypes.object,
    }).isRequired,
    reuniao: PropTypes.object,
    dataDescarte: PropTypes.string,
    situacao: PropTypes.number,
  }).isRequired,
};

function AlterarTipoReuniao({ id, callback = () => null, lead = {}, ...props }) {
  if (
    lead.situacao !== SITUACAO_LEAD.EM_OPERACAO ||
    (lead.reuniao &&
      (lead.reuniao.situacao !== SITUACAO_REUNIAO.VIGENTE && lead.reuniao.situacao !== SITUACAO_REUNIAO.REAGENDADA))
  )
    return null;

  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(o => !o);
  const permissaoNaEtapa = usePermissaoEtapa(lead.etapa);
  const { isGerente } = useUsuario();
  const hasPermission = lead.etapa && (isGerente || permissaoNaEtapa === PERMISSAO_ETAPA.INTERAGIR);

  if (!hasPermission || !lead.reuniao?.id) return null;

  return (
    <>
      <ActionButton
        id="btnAlterarTipoReuniao"
        type="icon"
        icon={<EditCalendar />}
        label={intl.formatMessage({ defaultMessage: "Alterar tipo de reunião" })}
        onClick={toggle}
        leads={lead}
        claim={permissions.ALTERAR_TIPO_REUNIAO}
        {...props}
      />
      <Dialog maxWidth="sm" fullWidth open={open} onClose={toggle}>
        <ModalAlterarTipoReuniao
          leadId={id ?? lead.id}
          tipoAtual={lead?.reuniao?.tipo}
          reuniaoId={lead.reuniao?.id}
          callback={callback}
          onClose={toggle}
        />
      </Dialog>
    </>
  );
}

export default AlterarTipoReuniao;
